<template>
  <ElDialog
    :visible="value"
    :title="$t('ADVERTISEMENT.NEW_CAMPAIGN_BASIC')"
    width="45%"
    @close="closeAndReset"
  >
    <ElSteps align-center finish-status="finish" :active="activeStep">
      <ElStep :title="$t('ADVERTISEMENT.SEARCH_ADS.CAMAPGIN_INFO_TITLE')" />
      <ElStep :title="$t('ADVERTISEMENT.NEW_CAMPAIGN_BASIC.STEPS.SET_PRICE')" />
    </ElSteps>

    <AddBasicCampaignGeneral
      v-show="activeStep === stepNumberMap.GENERAL_INFO"
      :apps="apps"
      :is-loading="isLoading"
      :reset-controller="resetController"
      @submit="submitGeneralInfoAndGoNext"
    />
    <AddBasicCampaignPrice
      v-show="activeStep === stepNumberMap.SET_PRICE"
      :is-loading="isLoading"
      :reset-controller="resetController"
      :credit="credit"
      @back="goPrevStep"
      @submit="submitPriceAndAddCampaign"
    />
  </ElDialog>
</template>

<script>
import AddBasicCampaignGeneral from './AddBasicCampaignGeneral';
import AddBasicCampaignPrice from './AddBasicCampaignPrice';
import createController from '@/utils/controller';
import { BasicAdsCampaigns } from '@/api/api';
import { AD_NEW_CAMPAIGN_CREATION_STATE, STATE } from '@/constants/gtm-events';
import { campaignTypes } from '../../../common/constants';
import { v4 as uuid } from 'uuid';
import normalizeNumber from '@/utils/normalizeNumbers';

const resetController = createController('reset');

const INITIAL_CAMPAIGN_MODEL = {
  name: '',
  packageName: '',
  budget: '',
  startDate: '',
  endDate: '',
  isPaused: false,
  clickTrackerLink: '',
  targetedCpi: '',
  isDiscoveryAdsEnabled: true,
};

function genInitialCampaignModel() {
  return {
    idempotencyKey: uuid(),
    ...INITIAL_CAMPAIGN_MODEL,
  };
}

export default {
  name: 'AddBasicCampaignModal',

  components: {
    AddBasicCampaignGeneral,
    AddBasicCampaignPrice,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    credit: {
      type: Number,
      required: true,
    },
    apps: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeStep: 0,
      isLoading: false,
      campaignModel: genInitialCampaignModel(),
    };
  },

  computed: {
    resetController() {
      return resetController;
    },
    stepNumberMap() {
      return {
        GENERAL_INFO: 0,
        SET_PRICE: 1,
      };
    },
  },

  methods: {
    submitGeneralInfoAndGoNext(data) {
      this.setData(data);
      this.goNextStep();
    },
    submitPriceAndAddCampaign(data) {
      this.setData(data);
      this.addCampaign();
    },
    goNextStep() {
      this.activeStep++;
    },
    goPrevStep() {
      this.activeStep--;
    },
    setData(data) {
      for (let prop in data) {
        if (prop in this.campaignModel) {
          this.campaignModel[prop] = data[prop];
        }
      }
    },
    addCampaign() {
      this.isLoading = true;

      return BasicAdsCampaigns.addCampaign({
        ...this.campaignModel,
        targetedCpi: Number(
          normalizeNumber(this.campaignModel.targetedCpi) || 0,
        ),
        budget: Number(normalizeNumber(this.campaignModel.budget) || 0),
      })
        .then(message => {
          this.$gtm.trackEvent(AD_NEW_CAMPAIGN_CREATION_STATE(STATE.SUCCESS));

          this.$message.success(message);

          this.closeAndReset();
          this.$emit('add', campaignTypes.BASIC);
        })
        .catch(({ message }) => {
          this.$gtm.trackEvent(AD_NEW_CAMPAIGN_CREATION_STATE(STATE.FAIL));

          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeAndReset() {
      this.$emit('input', false);
      this.resetController.reset();
      this.activeStep = 0;
      this.campaignModel = genInitialCampaignModel();
    },
  },
};
</script>
